import { useAuthorizationChecker } from 'authorization-scope';

export default useAuthorizationChecker;
